// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: #253750;
  font-size: 12px;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #edf1f6;
}
.dialog-header h2 {
  padding: 0;
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0;
}
.dialog-header h2::before {
  display: none;
}
.dialog-header p {
  margin: 5px 0 0;
  font-size: 12px;
  color: #7d8a9d;
  line-height: 18px;
}

.icon-button {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #7d8a9d;
  cursor: pointer;
}
.icon-button span {
  font-size: 20px;
}
.icon-button:hover {
  background: color-mix(in srgb, var(--primary-color) 6%, white);
  color: var(--primary-color);
}

.editor-content {
  padding: 22px 24px;
  max-height: 60vh;
}

.field-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 18px;
}

.field {
  min-width: 0;
}
.field > label {
  display: block;
  margin-bottom: 7px;
  font-size: 12px;
  font-weight: 500;
  color: #35445b;
}
.field > input {
  width: 100%;
  height: 38px;
  border: 1px solid #dce5ef;
  border-radius: 7px;
  padding: 0 10px;
  color: #253750;
  font: inherit;
  background: white;
  box-sizing: border-box;
}
.field > input::placeholder {
  color: #a0adbc;
  font-size: 11px;
}
.field > input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--primary-color) 7%, white);
}
.field > input[aria-invalid=true] {
  border-color: #d95656;
}
.field > input:disabled {
  color: #53647a;
  background: #fafbfd;
  opacity: 1;
}

.required {
  color: #cc4b4b;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid #dce5ef;
  border-radius: 20px;
  background: #f1f3f7;
  color: #53647a;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
}
.status-badge .material-symbols-outlined {
  font-size: 17px;
}
.status-badge.pending {
  background: #fff7e6;
  color: #895b00;
  border-color: #f2dfad;
}
.status-badge.approved {
  background: #eef7f2;
  color: #287457;
  border-color: #cce8db;
}
.status-badge.rejected {
  background: #fff0f0;
  color: #b43636;
  border-color: #f2d2d2;
}

.approval-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 22px;
  padding: 15px 16px;
  border: 1px solid #e2e9f2;
  border-radius: 9px;
  background: #fafbfd;
}

.approval-copy h3 {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #35445b;
  line-height: 18px;
}
.approval-copy p {
  margin: 4px 0 0;
  font-size: 11px;
  color: #64748b;
  line-height: 17px;
}

.error {
  margin: 5px 0 0;
  font-size: 11px;
  color: #c34242;
  line-height: 16px;
}

.edit-notice {
  margin: 18px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 19px;
}

.switch-row {
  position: relative;
  display: flex !important;
  align-items: center;
  gap: 10px;
  height: 38px;
  cursor: pointer;
}
.switch-row input {
  position: absolute;
  width: 34px;
  height: 20px;
  opacity: 0;
}
.switch-row input:checked + .switch-track {
  background: var(--primary-color);
}
.switch-row input:checked + .switch-track::after {
  transform: translateX(14px);
}
.switch-row input:focus-visible + .switch-track {
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 22%, white);
}
.switch-row input:disabled ~ span {
  opacity: 0.7;
  cursor: default;
}

.switch-track {
  display: block;
  width: 34px;
  height: 20px;
  border-radius: 20px;
  background: #bbc7d6;
  padding: 3px;
  box-sizing: border-box;
}
.switch-track::after {
  content: "";
  display: block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: white;
  transition: transform 150ms ease;
}

.dialog-footer {
  padding: 16px 24px;
  margin: 0;
  min-height: 0;
  gap: 8px;
  justify-content: flex-end;
  border-top: 1px solid #edf1f6;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  border: 1px solid #dce5ef;
  border-radius: 7px;
  padding: 7px 14px;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}
.button.secondary {
  background: white;
  color: #53647a;
}
.button.primary {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}
.button.danger {
  background: #c84343;
  border-color: #c84343;
}
.button:disabled {
  opacity: 0.45;
  cursor: default;
}
.button:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--primary-color) 40%, white);
  outline-offset: 2px;
}

.confirmation-content {
  padding: 24px;
  font-size: 13px;
  line-height: 21px;
}
.confirmation-content p {
  margin: 0;
}
.confirmation-content .muted {
  margin-top: 8px;
  color: #7d8a9d;
  font-size: 12px;
}

@media (max-width: 550px) {
  .field-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .dialog-header,
  .editor-content,
  .dialog-footer {
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/price-groups/price-group-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;AACF;AACE;EACE,UAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AACJ;AACI;EACE,aAAA;AACN;AAGE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAFF;AAIE;EACE,eAAA;AAFJ;AAKE;EACE,8DAAA;EACA,2BAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;AAJF;;AAOA;EACE,YAAA;AAJF;AAME;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;AALJ;AAOI;EACE,cAAA;EACA,eAAA;AALN;AAQI;EACE,aAAA;EACA,kCAAA;EACA,wEAAA;AANN;AASI;EACE,qBAAA;AAPN;AAUI;EACE,cAAA;EACA,mBAAA;EACA,UAAA;AARN;;AAaA;EACE,cAAA;AAVF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAVF;AAYE;EACE,eAAA;AAVJ;AAaE;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAXJ;AAcE;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAZJ;AAeE;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAdF;;AAkBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAfJ;AAkBE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAhBJ;;AAoBA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;AAjBF;AAmBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAjBJ;AAoBE;EACE,gCAAA;AAlBJ;AAoBI;EACE,2BAAA;AAlBN;AAsBE;EACE,yEAAA;AApBJ;AAuBE;EACE,YAAA;EACA,eAAA;AArBJ;;AAyBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;AAtBF;AAwBE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;AAtBJ;;AA0BA;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,QAAA;EACA,yBAAA;EACA,6BAAA;AAvBF;;AA0BA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AAvBF;AAyBE;EACE,iBAAA;EACA,cAAA;AAvBJ;AA0BE;EACE,gCAAA;EACA,kCAAA;EACA,YAAA;AAxBJ;AA2BE;EACE,mBAAA;EACA,qBAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,eAAA;AA1BJ;AA6BE;EACE,sEAAA;EACA,mBAAA;AA3BJ;;AA+BA;EACE,aAAA;EACA,eAAA;EACA,iBAAA;AA5BF;AA8BE;EACE,SAAA;AA5BJ;AA+BE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA7BJ;;AAiCA;EACE;IACE,0BAAA;IACA,SAAA;EA9BF;EAiCA;;;IAGE,aAAA;EA/BF;AACF","sourcesContent":[":host {\n  display: block;\n  color: #253750;\n  font-size: 12px;\n}\n\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 22px 24px 18px;\n  border-bottom: 1px solid #edf1f6;\n\n  h2 {\n    padding: 0;\n    margin: 0;\n    font-size: 17px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: 0;\n\n    &::before {\n      display: none;\n    }\n  }\n\n  p {\n    margin: 5px 0 0;\n    font-size: 12px;\n    color: #7d8a9d;\n    line-height: 18px;\n  }\n}\n\n.icon-button {\n  display: grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #7d8a9d;\n  cursor: pointer;\n\n  span {\n    font-size: 20px;\n  }\n\n  &:hover {\n    background: color-mix(in srgb, var(--primary-color) 6%, white);\n    color: var(--primary-color);\n  }\n}\n\n.editor-content {\n  padding: 22px 24px;\n  max-height: 60vh;\n}\n\n.field-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px 18px;\n}\n\n.field {\n  min-width: 0;\n\n  >label {\n    display: block;\n    margin-bottom: 7px;\n    font-size: 12px;\n    font-weight: 500;\n    color: #35445b;\n  }\n\n  >input {\n    width: 100%;\n    height: 38px;\n    border: 1px solid #dce5ef;\n    border-radius: 7px;\n    padding: 0 10px;\n    color: #253750;\n    font: inherit;\n    background: white;\n    box-sizing: border-box;\n\n    &::placeholder {\n      color: #a0adbc;\n      font-size: 11px;\n    }\n\n    &:focus {\n      outline: none;\n      border-color: var(--primary-color);\n      box-shadow: 0 0 0 2px color-mix(in srgb, var(--primary-color) 7%, white);\n    }\n\n    &[aria-invalid='true'] {\n      border-color: #d95656;\n    }\n\n    &:disabled {\n      color: #53647a;\n      background: #fafbfd;\n      opacity: 1;\n    }\n  }\n}\n\n.required {\n  color: #cc4b4b;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border: 1px solid #dce5ef;\n  border-radius: 20px;\n  background: #f1f3f7;\n  color: #53647a;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 18px;\n  white-space: nowrap;\n\n  .material-symbols-outlined {\n    font-size: 17px;\n  }\n\n  &.pending {\n    background: #fff7e6;\n    color: #895b00;\n    border-color: #f2dfad;\n  }\n\n  &.approved {\n    background: #eef7f2;\n    color: #287457;\n    border-color: #cce8db;\n  }\n\n  &.rejected {\n    background: #fff0f0;\n    color: #b43636;\n    border-color: #f2d2d2;\n  }\n}\n\n.approval-summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 22px;\n  padding: 15px 16px;\n  border: 1px solid #e2e9f2;\n  border-radius: 9px;\n  background: #fafbfd;\n}\n\n.approval-copy {\n  h3 {\n    margin: 0;\n    font-size: 12px;\n    font-weight: 600;\n    color: #35445b;\n    line-height: 18px;\n  }\n\n  p {\n    margin: 4px 0 0;\n    font-size: 11px;\n    color: #64748b;\n    line-height: 17px;\n  }\n}\n\n.error {\n  margin: 5px 0 0;\n  font-size: 11px;\n  color: #c34242;\n  line-height: 16px;\n}\n\n.edit-notice {\n  margin: 18px 0 0;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 19px;\n}\n\n.switch-row {\n  position: relative;\n  display: flex !important;\n  align-items: center;\n  gap: 10px;\n  height: 38px;\n  cursor: pointer;\n\n  input {\n    position: absolute;\n    width: 34px;\n    height: 20px;\n    opacity: 0;\n  }\n\n  input:checked+.switch-track {\n    background: var(--primary-color);\n\n    &::after {\n      transform: translateX(14px);\n    }\n  }\n\n  input:focus-visible+.switch-track {\n    box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 22%, white);\n  }\n\n  input:disabled~span {\n    opacity: .7;\n    cursor: default;\n  }\n}\n\n.switch-track {\n  display: block;\n  width: 34px;\n  height: 20px;\n  border-radius: 20px;\n  background: #bbc7d6;\n  padding: 3px;\n  box-sizing: border-box;\n\n  &::after {\n    content: '';\n    display: block;\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    background: white;\n    transition: transform 150ms ease;\n  }\n}\n\n.dialog-footer {\n  padding: 16px 24px;\n  margin: 0;\n  min-height: 0;\n  gap: 8px;\n  justify-content: flex-end;\n  border-top: 1px solid #edf1f6;\n}\n\n.button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 34px;\n  border: 1px solid #dce5ef;\n  border-radius: 7px;\n  padding: 7px 14px;\n  font: inherit;\n  font-size: 12px;\n  cursor: pointer;\n\n  &.secondary {\n    background: white;\n    color: #53647a;\n  }\n\n  &.primary {\n    background: var(--primary-color);\n    border-color: var(--primary-color);\n    color: white;\n  }\n\n  &.danger {\n    background: #c84343;\n    border-color: #c84343;\n  }\n\n  &:disabled {\n    opacity: .45;\n    cursor: default;\n  }\n\n  &:focus-visible {\n    outline: 2px solid color-mix(in srgb, var(--primary-color) 40%, white);\n    outline-offset: 2px;\n  }\n}\n\n.confirmation-content {\n  padding: 24px;\n  font-size: 13px;\n  line-height: 21px;\n\n  p {\n    margin: 0;\n  }\n\n  .muted {\n    margin-top: 8px;\n    color: #7d8a9d;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 550px) {\n  .field-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .dialog-header,\n  .editor-content,\n  .dialog-footer {\n    padding: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
